var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"d-block painel",attrs:{"src":"https://networkf5.com.br/apuracao-eleicoes-painel?uf=MT&city=89796","width":"100%","height":"100vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }